// Author yu jia bei
// Date 2024-06-13 19:10:00

class SithMesPrdPpScheduledResultPsr {
constructor({
        id = null,
        psrData = '',
        adjustType = '',
        adjustReason = '',
        adjustCauseProjectCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.psrData = psrData;
    this.adjustType = adjustType;
    this.adjustReason = adjustReason;
    this.adjustCauseProjectCode = adjustCauseProjectCode;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpScheduledResultPsr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'adjustType',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.adjustType',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'pp_header_schedule_reason_type'
                        }
        },
        {
        key: 'adjustReason',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.adjustReason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'adjustCauseProjectCode',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.adjustCauseProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdBy',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.createdBy',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.grid.remark',
        sortable: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    createdTimeRteFilter : '',
    createdTimeLteFilter : '',
    createdByFilter : '',
    adjustTypeFilter : '',
    adjustReasonFilter : '',
    adjustCauseProjectCodeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'createdTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.filter.createdTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.filter.createdTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdByFilter',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.filter.createdBy',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'adjustTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.filter.adjustType',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'pp_header_schedule_reason_type'
                }
        },
        {
        key: 'adjustReasonFilter',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.filter.adjustReason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'adjustCauseProjectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.filter.adjustCauseProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'psrData',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.entity.psrData',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'adjustType',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.entity.adjustType',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'pp_header_schedule_reason_type'
                }
        },
        {
        key: 'adjustReason',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.entity.adjustReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'adjustCauseProjectCode',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.entity.adjustCauseProjectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpScheduledResultPsr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdPpScheduledResultPsr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
